import { Outlet } from "react-router-dom";
import AppNavBar from "../components/navbar/AppNavBar";

export default function HomeLayout() {
    return(<div>
        <AppNavBar />
        <Outlet />
    </div>)
}